import { BasicMod } from "@src/store/slices/experienceBuilder/types";
import { createSlice } from "@reduxjs/toolkit";
import { IBasicModState } from "@src/store/slices/experienceBuilder/basicMod/types";
import { actions } from "@src/store/slices/experienceBuilder/common/actions";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

const initialState: IBasicModState = {};

const clearDraft = (_state: IBasicModState) => initialState;

export const basicModSlice = createSlice({
  name: "experienceBuilderBasicMod",
  initialState,
  reducers: (create) => ({
    _initDraft: create.reducer<BasicMod>((state, action) => {
      state.draft = action.payload;
      state.initialDraft = action.payload;
    }),
    setDraft: create.reducer<BasicMod | undefined>((state, action) => {
      if (state.draft && action.payload) {
        state.draft = action.payload;
        if ("groupId" in state.draft && "selector" in action.payload) {
          state.draft.groupId = action.payload.selector;
        }
      }
    }),
    clearDraft: create.reducer(clearDraft),
  }),
  extraReducers: (builder) => {
    builder.addCase(experienceBuilderSlice.actions.initBuilder, clearDraft);
    builder.addCase(actions.clearDraft, clearDraft);
    builder.addCase(
      experienceBuilderSlice.actions.setEmbeddedNodes,
      (state, action) => {
        const draft = state.draft;
        if (draft?.type === "text" || draft?.type === "image") {
          if (draft.nodes.length > 0) return;
          const node = action.payload[draft.selector];
          if (node) {
            draft.nodes = [node];
            if (!draft.html) draft.html = node.html;
          }
        }
      }
    );
  },
  selectors: {
    getDraft: (state) => state.draft,
    getInitialDraft: (state) => state.initialDraft,
    isActive: (state) => state.draft !== undefined,
  },
});
